import React from 'react';
import './styles.css'; // Import styles for the component
export function FormLabel(_a) {
    var htmlFor = _a.htmlFor, children = _a.children;
    return React.createElement("label", { htmlFor: htmlFor, className: "form-label" }, children);
}
export function FormHelperText(_a) {
    var children = _a.children;
    return React.createElement("span", { className: "form-helper-text" }, children);
}
export function FormControl(_a) {
    var children = _a.children, error = _a.error, style = _a.style, dataTestId = _a["data-testid"];
    return (React.createElement("div", { className: "form-control ".concat(error ? 'form-control-error' : ''), style: style, "data-testid": dataTestId }, children));
}
//# sourceMappingURL=FormControl.js.map